// Course display names, keyed by the courseSlug stored on webinar registrations, landing
// applications and clarity-call bookings (see server/constants/courses.js for the slug list).
const COURSES = {
  "data-ai": "Data & AI",
  "software-engineering": "Software Engineering",
  "cloud-network-infrastructure": "Cloud & Network Infrastructure",
  "cyber-security": "Cyber Security",
  general: "General",
};

// Label for a record's courseSlug. Returns "" when the record has none — landing applications
// submitted without a course, and older records, carry no slug — so callers can show a dash.
// An unrecognised slug is shown as-is rather than hidden.
export function courseLabel(slug) {
  if (!slug) return "";
  return COURSES[slug] || slug;
}

// [{ value, label }] for course filter selects — a module-level constant (stable reference).
export const COURSE_OPTIONS = Object.entries(COURSES).map(([value, label]) => ({ value, label }));
